var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFolderOutline20Old = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 5C3 3.89543 3.89543 3 5 3H8.38197C9.13951 3 9.83204 3.428 10.1708 4.10557L10.618 5H14C15.6569 5 17 6.34315 17 8V14C17 15.6569 15.6569 17 14 17H6C4.34315 17 3 15.6569 3 14V5ZM8.38197 5H5V14C5 14.5523 5.44772 15 6 15H14C14.5523 15 15 14.5523 15 14V8C15 7.44772 14.5523 7 14 7H9.38197L8.38197 5Z",
  fill: "currentColor"
})));
export { SvgFolderOutline20Old as ReactComponent };